import { ReactNode } from 'react';

import buttonStyles from './Button.module.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode; // Allows you to pass content to the button
  variant?: 'primary' | 'secondary'; // Optional variant for styling
}

export const Button: React.FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <button className={buttonStyles.button} {...props}>
      {children}
    </button>
  );
};
